import { useCallback, useEffect, useRef, useState } from "react";
import "../styles/imageslider.css";
import JsonData from "../data/data.json";

const UpcomingEventSlider = ({ slides}) => {
  const timerRef = useRef(null);
  const [SliderPageData, setSliderPageData] = useState([]);
  
  useEffect(() => {
    setSliderPageData(JsonData.Slider);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  console.log(slides);
  console.log(JsonData.Slider);

  const goToNext = useCallback(() => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides]);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      goToNext();
    }, 5000);

    return () => clearTimeout(timerRef.current);
  }, [goToNext]);

  const slidesContainerStyles = {
    display: "flex",
    height: "80vh",
    transition: "transform ease-out 1.8s",
    width: `${slides.length * 100}%`,
    transform: `translateX(${-(currentIndex * (100 / slides.length))}%)`,
  };

  return (
    <div className="sliderStyles">
      <div className="slidesContainerOverflowStyles">
        <div style={slidesContainerStyles}>
        {
        slides.length > 0 ?
        slides.map((slide, slideIndex) => (
          <div key={slideIndex} className="slidestyle">
            <img src={slide} alt={`Slide ${slideIndex}`} className="imgStyles"/>
          </div>
        ))
        :
        SliderPageData && SliderPageData.map((slide,index)=>(
          <div key={index} className="slidestyle">
            <img src={slide.imageUrl} alt={`Slide ${index}`} className="imgStyles"/>
          </div>
        ))
        }
        </div>
      </div>
    </div>
  );
};

export default UpcomingEventSlider;
